import { useSelector } from 'react-redux';

import styles from './styles.module.scss';

import {
  MetricChartDew,
  MetricChartDewDuration,
  MetricChartGdd,
  MetricChartHumidity,
  MetricChartNdvi,
  MetricChartSoilMoisture,
  MetricChartSoilTemperature,
  MetricChartTemperature,
} from './index.jsx';
import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';
import { getMetricsLabels } from '../../utils/metrics';

const MetricsCharts = ({ t, data, crop, showSoilData }) => {
  const { widthViewport } = useViewport();
  const { activeReportChart } = useSelector((state) => state.sensors);
  const MetricsLabels = getMetricsLabels(t);

  return (
    <div className={styles.metricsChartsContainer}>
      <div className={styles.metricsCharts}>
        {/*Temperature*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'temperature') && (
          <MetricChartTemperature
            title={MetricsLabels.temperature}
            data={data.temperature}
            crop={crop}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        )}
        {/*GDD*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'gdd') && (
          <MetricChartGdd
            title={MetricsLabels.gdd}
            data={data.gdd}
            crop={crop}
            sensor={data.sensor}
            widthViewport={widthViewport}
            t={t}
          />
        )}
        {/*Dewfall Duration*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'dewDuration') && (
          <MetricChartDewDuration
            title={MetricsLabels.dewfallDuration}
            data={data.dewDuration}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        )}
        {/*Humidity*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'humidity') && (
          <MetricChartHumidity
            title={MetricsLabels.humidity}
            data={data.humidity}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        )}
        {/*Dew Point*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'dew') && (
          <MetricChartDew
            title={MetricsLabels.dewPoint}
            data={data.dew}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        )}
        {/*Plant NDVI*/}
        {(widthViewport > BreakpointMobile || activeReportChart === 'ndvi') && (
          <MetricChartNdvi
            title={MetricsLabels.plantNdvi}
            data={data.ndvi}
            sensor={data.sensor}
            widthViewport={widthViewport}
          />
        )}
      </div>
      {showSoilData && (
        <div className={styles.metricsCharts} style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {/*Soil Temperature*/}
          {(widthViewport > BreakpointMobile || activeReportChart === 'soilTemperature') && (
            <MetricChartSoilTemperature
              title={MetricsLabels.soilTemperature}
              data={data.soilTemperature}
              sensor={data.sensor}
              widthViewport={widthViewport}
            />
          )}
          {/*Soil Moisture*/}
          {(widthViewport > BreakpointMobile || activeReportChart === 'soilMoisture') && (
            <MetricChartSoilMoisture
              title={MetricsLabels.soilMoisture}
              data={data.soilMoisture}
              sensor={data.sensor}
              widthViewport={widthViewport}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MetricsCharts;
